/** @jsx jsx */
/** @jsxFrag null */
import range from 'lodash/range';
import {jsx} from 'panel';

import type {SkeletonList} from './index';

export function template(this: SkeletonList) {
  return (
    <div sel='.mp-skeleton-wrapper'>
      {range(0, this.attr(`num-rows`)).map((_) => (
        <div class={{[`mp-skeleton-${this.attr(`row-size`)}`]: true}} />
      ))}
    </div>
  );
}
